import API from '../api/api'
import {_exportDownloadLinkDecorator} from '../helper'

const SYNC_NAVIGATION_PENDING = 'SYNC_NAVIGATION_PENDING'
const SYNC_NAVIGATION_PROGRESS = 'SYNC_NAVIGATION_PROGRESS'
const SYNC_NAVIGATION_RESPONSE = 'SYNC_NAVIGATION_RESPONSE'
const SAVE_NAVIGATION_PENDING = 'SAVE_NAVIGATION_PENDING'
const SAVE_NAVIGATION_PROGRESS = 'SAVE_NAVIGATION_PROGRESS'
const SAVE_NAVIGATION_RESPONSE = 'SAVE_NAVIGATION_RESPONSE'
const SAVE_NAVIGATION_ABORTED = 'SAVE_NAVIGATION_ABORTED'

const EXPORT_NAVIGATION_PENDING = 'EXPORT_NAVIGATION_PENDING'
const EXPORT_NAVIGATION_PROGRESS = 'EXPORT_NAVIGATION_PROGRESS'
const EXPORT_NAVIGATION_RESPONSE = 'EXPORT_NAVIGATION_RESPONSE'

const IMPORT_NAVIGATION_PENDING = 'IMPORT_NAVIGATION_PENDING'
const IMPORT_NAVIGATION_PROGRESS = 'IMPORT_NAVIGATION_PROGRESS'
const IMPORT_NAVIGATION_RESPONSE = 'IMPORT_NAVIGATION_RESPONSE'

const RESET_ERRORS = 'RESET_ERRORS'
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS'

const initialState = {
  sync_navigation_pending: true,
  save_navigation_pending: false,
  export_navigation_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  import_navigation_pending: false,
  imported_entries: 0,
  progress: 0,
  links: [],
  error: false
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case SYNC_NAVIGATION_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_navigation_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case SYNC_NAVIGATION_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_NAVIGATION_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          sync_navigation_pending: false,
          error: false,
          links: action.response.links
        }
      } else {
        return {
          ...state,
          sync_navigation_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case SAVE_NAVIGATION_PENDING: {
      return {
        ...state,
        progress: 0,
        save_navigation_pending: true,
        error: false,
      }
    }
    case SAVE_NAVIGATION_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    // A save dropped because the merchant left the language never answers, and nothing refires
    // it the way a switch refires the sync - so the flag it set is cleared here. Not an error:
    // the merchant asked for the interruption.
    case SAVE_NAVIGATION_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_navigation_pending: false,
        error: false,
      }
    }
    case SAVE_NAVIGATION_RESPONSE: {
      // The response echoes what was written for the language the save was issued for. The
      // abort races a response already on the wire, so it can still land after the merchant
      // selected another language - applying it then is what puts one language's text under another.
      if(action.stale === true) {
        return {
          ...state,
          save_navigation_pending: false,
          error: false,
        }
      }

      let error = false;
      let newLinks = state.links.slice();
      action.response.forEach((response, i) => {
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
          let newLink = newLinks.find(x => x.id == action.items[i].id)
          newLink.target = action.items[i].title
        } else {
          let newLink = newLinks.find(x => x.id == response.link.id)
          newLink.progress = response.link.progress
          newLink.source = response.link.source
          newLink.target = response.link.target
        }
      })
      return {
        ...state,
        links: newLinks,
        save_navigation_pending: false,
        error: error,
      }
    }

    case EXPORT_NAVIGATION_PENDING: {
      return {
        ...state,
        progress: 0,
        export_navigation_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case EXPORT_NAVIGATION_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_NAVIGATION_RESPONSE: {
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_navigation_pending: false,
          export_po_download_url: _exportDownloadLinkDecorator(action.response.po_download_url, action.options),
          export_csv_download_url: _exportDownloadLinkDecorator(action.response.csv_download_url, action.options),

        }
      } else {
        return {
          ...state,
          progress: 100,
          export_navigation_pending: false,
          error: {
            message: action.response,
            action: action.action,
          },
        }
      }
    }

    case IMPORT_NAVIGATION_PENDING: {
      return {
        ...state,
        progress: 0,
        import_navigation_pending: true,
        import_cancelled: false,
        imported_entries: 0,
        error: false,
      }
    }
    case IMPORT_NAVIGATION_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_NAVIGATION_RESPONSE: {
      // the merchant cancelled after reviewing the file, nothing was imported
      if(action.response && action.response.cancelled === true) {
        return {
          ...state,
          progress: 0,
          import_navigation_pending: false,
          import_cancelled: true
        }
      }
      let isOk = true;
      let importedEntries = 0;
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          importedEntries += response.imported_entries
        }
      })

      if(isOk == true) {
        return {
          ...state,
          progress: 100,
          import_navigation_pending: false,
          imported_entries: importedEntries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_navigation_pending: false,
          imported_entries: importedEntries,
          error: {
            message: action.response.filter(response => response.success !== true),
            action: action.action,
          },
        }
      }
    }
    case CLEAR_EXPORT_URLS: {
      return {
        ...state,
        progress: 0,
        export_navigation_pending: false,
        export_csv_download_url: null,
        export_po_download_url: null,
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}
export const syncNavigation = (language, callback, options = {}) => {
  return dispatch => {
    // A held sync is the bulk tool's own work: it runs and answers its callback,
    // but nothing of it reaches the store
    const mirror = (action) => {
      if(options.held !== true) {
        dispatch(action);
      }
    }
    mirror({
      type: SYNC_NAVIGATION_PENDING
    })

    API.syncNavigation(
      language,
      progress => {
        mirror({
          type: SYNC_NAVIGATION_PROGRESS,
          progress: progress
        })
      },
      response => {
        // A dropped sync is not dispatched at all: the switch that dropped it has already
        // started the sync for the language now on screen, and that one owns the pending flag.
        if(response && response.aborted === true) {
          // The answer is dropped, but the callback still fires: callers use it to resolve a
          // promise, and one that never hears back leaves the ui waiting for good.
          if(callback) {
            callback(response);
          }
          return;
        }

        mirror({
          type: SYNC_NAVIGATION_RESPONSE,
          response: response,
          action: () => syncNavigation(language, callback)
        });
        if(callback) {
          callback(response);
        }
    }, options)
  }
}

export const saveNavigation = (language, items) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_NAVIGATION_PENDING
    })

    API.saveNavigation(
      language,
      items,
      progress => {
        dispatch({
          type: SAVE_NAVIGATION_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_NAVIGATION_ABORTED
          })
          return;
        }

        dispatch({
          type: SAVE_NAVIGATION_RESPONSE,
          response: response,
          items: items,
          stale: getState().shop.shop.edit_language !== language,
          action: () => saveNavigation(language, items)
        })
      })
  }
}

export const exportNavigation = (language, options) => {
  return dispatch => {
    dispatch({
      type: EXPORT_NAVIGATION_PENDING
    })

    API.exportNavigation(
      language,
      options,
      progress => {
        dispatch({
          type: EXPORT_NAVIGATION_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_NAVIGATION_RESPONSE,
          response: response,
          options: options,
          action: () => exportNavigation(language, options)
        }
      )
    })
  }
}

export const importNavigation = (file, fileType, language) => {
  return dispatch => {
    dispatch({
      type: IMPORT_NAVIGATION_PENDING
    })

    API.importNavigation(
      file,
      fileType,
      language,
      progress => {
        dispatch({
          type: IMPORT_NAVIGATION_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_NAVIGATION_RESPONSE,
          response: response,
          action: () => importNavigation(file, fileType, language)
        }
      )
    })
  }
}

export const clearExportUrls = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_EXPORT_URLS
    });
  }
}